module.exports = __webpack_public_path__ + "img/fitness1.0e32d3ac.png";